import { useEffect } from "react"

import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom"

import { useGetEnabledModulesInApp } from "@l2r-front/l2r-networks"
import { BottomSheetMobileLayout } from "@l2r-front/l2r-ui"

import { RiskZonesMapLayersRouter } from "../../../modules/riskZones/routers/RiskZonesMapLayersRouter"
import { RiskZonesMobileRoutes } from "../../../modules/riskZones/routers/RiskZonesRoutes"
import { SpeedingsMapLayersRouter } from "../../../modules/speedings/routers/SpeedingsMapLayersRouter"
import { SpeedingsMobileRoutes } from "../../../modules/speedings/routers/SpeedingsRoutes"
import { appSafety } from "../../constants/appSafety"
import { MODULE_RISK_ZONES, MODULE_SPEEDINGS } from "../../constants/modules"
import { Map } from "../../containers/Map"

export function SafetyMobileRouter() {

    const enabledSafetyModule = useGetEnabledModulesInApp(appSafety)
    const location = useLocation()
    const matchEnabledModule = enabledSafetyModule?.find(m => location.pathname.includes(m.path))
    const navigate = useNavigate()

    useEffect(() => {
        if (!matchEnabledModule) {
            navigate(`${enabledSafetyModule?.[0]?.path || ""}`)
        }
    }, [enabledSafetyModule, matchEnabledModule, navigate])

    return (
        <Routes>
            <Route
                path={`/${MODULE_RISK_ZONES}/*`}
                element={<BottomSheetMobileLayout BottomSheetRouter={RiskZonesMobileRoutes} MapComponent={Map} MapRouter={RiskZonesMapLayersRouter} />}
            />
            <Route
                path={`/${MODULE_SPEEDINGS}/*`}
                element={<BottomSheetMobileLayout BottomSheetRouter={SpeedingsMobileRoutes} MapComponent={Map} MapRouter={SpeedingsMapLayersRouter} />}
            />
            <Route
                path="/*"
                element={<Navigate replace to={enabledSafetyModule?.[0]?.path ? enabledSafetyModule?.[0]?.path : ""} />}
            />
        </Routes>
    )
}
